import { createElementBlock as t, openBlock as a, createElementVNode as n } from "vue";
const o = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 20 20"
};
function c(r, e) {
  return a(), t("svg", o, [...e[0] || (e[0] = [
    n("path", {
      fill: "currentColor",
      d: "M6.273 9.395a4.6 4.6 0 0 1 .055-1.811c.181-.787.538-1.334.867-1.334.201 0 .23.052.244.078.069.126.313.854-.987 3.635a2.3 2.3 0 0 1-.179-.568m11.852-5.02v11.25a1.25 1.25 0 0 1-1.25 1.25H3.125a1.25 1.25 0 0 1-1.25-1.25V4.375a1.25 1.25 0 0 1 1.25-1.25h13.75a1.25 1.25 0 0 1 1.25 1.25M6.563 12.5q.232-.421.46-.87c.808-.025 1.736-.592 2.772-1.694.39.757.889 1.191 1.474 1.293q.939.16 1.87-.875c.469.432 1.262.896 2.484.896a.625.625 0 1 0 0-1.25c-1.399 0-1.898-.85-1.94-.927a.61.61 0 0 0-.832-.288.6.6 0 0 0-.246.217c-.53.782-.927 1.028-1.124.995-.312-.054-.715-.781-.877-1.406a.625.625 0 0 0-1.094-.235c-.694.855-1.273 1.39-1.729 1.692 1.235-2.785 1.037-3.796.75-4.32C8.387 5.456 8.015 5 7.195 5c-.972 0-1.751.86-2.085 2.302a5.9 5.9 0 0 0-.065 2.328c.133.696.404 1.23.794 1.572-.234.454-.476.893-.703 1.298h-.761a.625.625 0 1 0 0 1.25h.034c-.332.556-.555.906-.56.913a.625.625 0 1 0 1.053.674c.028-.043.427-.67.96-1.587h9.763a.624.624 0 1 0 0-1.25z"
    }, null, -1)
  ])]);
}
const i = { render: c };
export {
  i as default,
  c as render
};
